import React from 'react';
import { Helmet } from 'react-helmet-async';
import { 
  generateImageSchema, 
  generateImageGallerySchema, 
  generatePersonWithImagesSchema 
} from '../utils/imageMetadata';

/**
 * ImageStructuredData Component
 * Injects JSON-LD structured data for images to help Google Image Search
 * 
 * @param {string} type - Type of schema: 'single', 'gallery', 'person', or 'all'
 * @param {string} imageKey - Key from imageMetadata (for single image)
 */
const ImageStructuredData = ({ type = 'all', imageKey = null }) => {
  const renderSchema = () => {
    switch (type) {
      case 'single':
        if (!imageKey) return null;
        return (
          <script type="application/ld+json">
            {JSON.stringify(generateImageSchema(imageKey))}
          </script>
        );
      
      case 'gallery':
        return (
          <script type="application/ld+json">
            {JSON.stringify(generateImageGallerySchema())}
          </script>
        );
      
      case 'person':
        return (
          <script type="application/ld+json">
            {JSON.stringify(generatePersonWithImagesSchema())}
          </script>
        );
      
      case 'all':
      default:
        return (
          <>
            <script type="application/ld+json">
              {JSON.stringify(generateImageGallerySchema())}
            </script>
            <script type="application/ld+json">
              {JSON.stringify(generatePersonWithImagesSchema())}
            </script>
          </>
        );
    }
  };

  return (
    <Helmet>
      {renderSchema()}
    </Helmet>
  );
};

export default ImageStructuredData;
